import React from 'react';
import {MasterLayout} from 'components/layouts';
import {FAQ} from 'components/faq';
import title from 'constants/TitlePages.js';
import {Faq} from 'api';
import { asyncConnect } from 'redux-connect';

@asyncConnect([{
  key: 'faqs',
  promise: ({ match: { params }, helpers }) => {
    let _params = {
      filter: {
        limit: 100,
        order: 'createdAt ASC'
      }
    };
    return Faq.actions.list.request(_params).then(response => {
      return Promise.resolve(response.data)
    }).catch(err => {
      console.log(err)
    });

  }
}])
class FAQPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    }
  }

  componentDidMount() {
    document.title = title.FAQPage;
  }

  render() {
    return (
      <MasterLayout isActive='faq'>
        {this.props.faqs &&
          <FAQ data={this.props.faqs}/>
        }

      </MasterLayout>
    );
  }
}

export default FAQPage;



// WEBPACK FOOTER //
// ./pages/faq/FAQPage.jsx